/** Keeps AuthContext.disableComposer in sync with subscription + onboarding gates. */

import { useEffect, useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useSubscriptionContext } from "@/contexts/SubscriptionContext";
import { isSubscriptionComposerDisabled } from "@/helpers/composerGate.helper";
import { useOnboardingContext } from "@/contexts/OnboardingContext";

export function ComposerGateSync() {
  const { setDisableComposer } = useAuth();
  const { subscriptionData } = useSubscriptionContext();
  const { composerDisabledByOnboarding } = useOnboardingContext();

  const subscriptionBlocked = useMemo(
    () => isSubscriptionComposerDisabled(subscriptionData),
    [subscriptionData],
  );

  useEffect(() => {
    setDisableComposer(subscriptionBlocked || composerDisabledByOnboarding);
  }, [subscriptionBlocked, composerDisabledByOnboarding, setDisableComposer]);

  return null;
}
